import React from 'react';
import Loader from "react-loader-spinner";
import { MdClose } from 'react-icons/md';

const WarningModal = ({ showModal, handleCancel, handleOk, buttonLoading, t }) => (
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("refunds.refundUpdateStatus")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                           <p>Do you want to continue?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" disabled={buttonLoading} onClick={handleCancel}>{t("jobsManagement.infoJob.receiptStatus.cancel")}</button>
                            <button type="button" className="btn btn-danger font-weight-bold d-flex align-items-center" disabled={buttonLoading} onClick={handleOk}>
                                {t("jobsManagement.infoJob.receiptStatus.processed")} {(buttonLoading) && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );

export default WarningModal;
